module.exports = __webpack_public_path__ + "img/partner14.0049ff1a.png";